<app-modal-component [open]="openModal" labelledBy="eu-title" (dismiss)="closeModal()">
  <div class="set-modal">
    <form [formGroup]="editForm" (ngSubmit)="handleSubmit()" novalidate>
      <header class="set-modal__head">
        <div class="set-modal__intro">
          <h2 class="set-modal__title" id="eu-title">{{ isSelf ? 'Edit your details' : 'Edit ' + (fullName || 'person') }}</h2>
          <p class="set-modal__sub">
            {{ isSelf ? 'Your name, number and roles.' : 'Their name, number and what they can do in Black Konnect.' }}
          </p>
        </div>
        <button type="button" class="bk-icon-btn" aria-label="Close" (click)="closeModal()">
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      </header>

      <div class="set-modal__body">
        @if (errorMsg) {
          <p class="set-alert" role="alert">
            <span class="bk-sym" aria-hidden="true">error</span>
            <span>{{ errorMsg }}</span>
          </p>
        }

        <div class="set-grid">
          <input-field
            label="First name"
            [errorMessage]="submitted && getFormInput('firstName')?.invalid ? 'Enter their first name.' : ''"
          >
            <input class="input-style" autocomplete="off" placeholder="First name" formControlName="firstName" />
          </input-field>

          <input-field
            label="Last name"
            [errorMessage]="submitted && getFormInput('lastName')?.invalid ? 'Enter their last name.' : ''"
          >
            <input class="input-style" autocomplete="off" placeholder="Last name" formControlName="lastName" />
          </input-field>

          <input-field
            class="is-wide"
            label="Email address"
            [hint]="isSelf ? 'You sign in with this address.' : 'They sign in with this address.'"
            [errorMessage]="submitted && getFormInput('emailAddress')?.invalid ? emailErrorMsg : ''"
          >
            <input
              class="input-style"
              type="email"
              autocomplete="off"
              placeholder="name@company.com"
              formControlName="emailAddress"
            />
          </input-field>

          <input-field
            class="is-wide"
            label="Phone number"
            [errorMessage]="
              submitted && getFormInput('primaryContactNumber')?.invalid ? 'Enter a phone number for them.' : ''
            "
          >
            <ngx-mat-input-tel
              formControlName="primaryContactNumber"
              [enablePlaceholder]="true"
              [preferredCountries]="['bw', 'za']"
              [enableSearch]="true"
            />
          </input-field>
        </div>

        <!-- Roles: what this person can do -->
        <fieldset class="set-roles" [class.is-invalid]="submitted && getFormInput('roles')?.invalid">
          <legend class="set-label">Roles</legend>
          <div class="set-roles__list">
            @for (role of roleOptions; track role.name) {
              <label class="set-role" [class.is-locked]="!!lockReason(role)">
                <input
                  type="checkbox"
                  [checked]="isSelected(role)"
                  [disabled]="!!lockReason(role)"
                  (change)="toggleRole(role, $event)"
                />
                <span class="set-role__name">{{ label(role) }}</span>
                @if (describe(role)) {
                  <span class="set-role__desc">{{ describe(role) }}</span>
                }
                @if (lockReason(role)) {
                  <span class="set-role__lock">
                    <span class="bk-sym" aria-hidden="true">lock</span>{{ lockReason(role) }}
                  </span>
                }
              </label>
            } @empty {
              <p class="set-role set-role__desc">
                {{ settingsService.isFetching ? 'Loading roles…' : 'The roles did not load. Close this window and try again.' }}
              </p>
            }
          </div>
          @if (submitted && getFormInput('roles')?.invalid) {
            <p class="set-roles__error" role="alert">
              <span class="bk-sym" aria-hidden="true">error</span>Choose at least one role.
            </p>
          }
        </fieldset>
      </div>

      <footer class="set-modal__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <customizable-button title="Save changes" className="w-full" [loading]="loading" [disabled]="loading" type="submit" />
      </footer>
    </form>
  </div>
</app-modal-component>
